import React from "react";
import "./Home.css";
import work1 from "../../assets/images/work1.png";
import work2 from "../../assets/images/work-step-2.png";
import work3 from "../../assets/images/work-step-3.png";
import work4 from "../../assets/images/work-step-4.png";


function Work({ homeSettings = {} }) {
  const title = (homeSettings.home_work_title && homeSettings.home_work_title.trim() !== "") ? homeSettings.home_work_title : "How It Works";
  const description = (homeSettings.home_work_description && homeSettings.home_work_description.trim() !== "") ? homeSettings.home_work_description : "Compassionate nursing care, physiotherapy, and bedside assistance tailored for patient comfort, recovery, and daily healthcare support.";

  return (
    <div className="howwork_section">
      <div className="container-fluid">
        <div className="section_heading  row text-center"> 
          <div className="content_part col-lg-12 col-sm-12 col-12">
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
        </div>
        <div className="work_boxes_outer">
          <div className="work_boxes_inner">
            <div className="step-connector">
              <span className="progress-line"></span>
            </div>
            <img src={work1} alt="work-step-1" className="img-fluid " />
            <div class="work-title">Choose Your Service</div>
            <p>
             Select nursing care, physiotherapy, diagnostics, ICU setup, or doctor consultation.

            </p>
          </div>
          <div className="work_boxes_inner">
             <div className="step-connector">
              <span className="progress-line"></span>
            </div>
            <img src={work2} alt="work-step-2" className="img-fluid " />
            <div className="work-title">Book an Appointment</div> 
            <p>
             Call us or fill out the online booking form to schedule your appointment quickly and conveniently.

            </p>
          </div>
          <div className="work_boxes_inner">
             <div className="step-connector">
              <span className="progress-line"></span>
            </div>
            <img src={work4 }alt="work-step-3" className="img-fluid " />
             <div className="work-title">Receive Care at Home</div> 
            <p>
            Call us or fill out the online booking form to schedule your appointment quickly and conveniently in just a few steps.
            </p>
          </div>
          <div className="work_boxes_inner">
             
            <img src={work3} alt="work-step-4" className="img-fluid " />
             <div className="work-title">Ongoing Monitoring</div>  
            <p>
             We provide follow-up support and progress monitoring for better recovery outcomes.

            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
